module.exports = __webpack_public_path__ + "static/media/bulb.c060f47f.jpg";